import React, { useState } from "react";
import { BookServiceModal } from "./BookService/BookServiceModal";
import { Button, Dropdown, Modal } from "react-bootstrap";
import EditServiceModal from "./EditServiceModal";

export default function UserServiceBox({ data, updateService }) {
  const storage_url = process.env.REACT_APP_STORAGE_URL;
  const isAdmin = localStorage.getItem("isAdmin");
  const [show, setShow] = useState(false);
  const statusOptions = ["published", "expired"];
  const [selectedStatus, setSelectedStatus] = useState("");

  const toggleShow = () => setShow(!show);
  const isExpired = () => (data.status === statusOptions[1] ? true : false);

  return (
    <div className="col-md-6">
      <div className="user-service-box p-1 mx-1 my-2 corner-radius">
        {isAdmin != 0 && (
          <div className="d-flex gap-1 edit-actions">
            <EditServiceModal data={data} updateService={updateService} />
            <Dropdown>
              <Dropdown.Toggle
                variant="primary"
                size="sm"
                id="dropdown-basic"
                className="text-capitalize"
              >
                {data.status}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {statusOptions.map((item, i) => {
                  if (data.status !== item) {
                    return (
                      <Dropdown.Item
                        key={i}
                        className="text-capitalize"
                        onClick={() => {
                          setSelectedStatus(item);
                          toggleShow();
                        }}
                      >
                        {item}
                      </Dropdown.Item>
                    );
                  }
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
        <img src={storage_url + data.imagePath} alt="" className="mb-3" />
        <div className="px-2 pb-2">
          <h5 className="mb-0">{data.title}</h5>
          <p>{data.description}</p>
          <div className="d-flex justify-content-between align-items-center">
            <h4 className={`mb-0 ${isExpired() && "text-muted"}`}>
              £{data.sessionPrice}
            </h4>
            <BookServiceModal serviceData={data} isExpired={isExpired} />
          </div>
        </div>
      </div>
      <Modal show={show} size="md" onHide={toggleShow} centered>
        <Modal.Body>
          <p className="fs-5 text-center">
            Are you sure you want to change the status?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            size="sm"
            type="button"
            onClick={toggleShow}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            type="submit"
            onClick={() =>
              updateService(data.serviceId, { ...data, status: selectedStatus })
            }
          >
            Update Status
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
